import {
  ESavedSearchActionTypes,
  IChangeFrequencySavedSearchPayload,
  IChangeTitleSavedSearchPayload,
  IRemoveSavedSearchPayload,
  ISetSavedSearchPayload,
} from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setSavedSearches = actionGenerator<ESavedSearchActionTypes.Set, ISetSavedSearchPayload>(
  ESavedSearchActionTypes.Set,
);

export const removeSavedSearches = actionGenerator<ESavedSearchActionTypes.Remove, IRemoveSavedSearchPayload>(
  ESavedSearchActionTypes.Remove,
);

export const changeFrequency = actionGenerator<
  ESavedSearchActionTypes.ChangeFrequency,
  IChangeFrequencySavedSearchPayload
>(ESavedSearchActionTypes.ChangeFrequency);

export const changeTitle = actionGenerator<ESavedSearchActionTypes.ChangeTitle, IChangeTitleSavedSearchPayload>(
  ESavedSearchActionTypes.ChangeTitle,
);
